/**
 * Static carrier profile UI constants (Phase 13).
 * No React — safe to import from hooks and presenters.
 */

export const CARRIER_PROFILE_POSITIONS = [
  "Underwriter",
  "Underwriting Assistant",
  "Manager",
  "Vice President",
  "Marketing Representative",
];

export const CARRIER_PROFILE_STATUSES = ["Available", "Unavailable"];

export const CARRIER_PROFILE_PRIORITIES = Array.from({ length: 10 }, (_, i) => i + 1);

/** Rounded tables used across profile tabs — matches legacy StateDetails-style cards */
export const CARRIER_PROFILE_TABLE_CARD_SX = {
  width: "100%",
  mb: 2,
  borderRadius: "12px",
  overflow: "hidden",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
};

export const CARRIER_PROFILE_HEADER_ROW_SX = {
  backgroundColor: "#f5f5f5",
  "& th": { fontWeight: 600 },
};

export const CARRIER_PROFILE_PAGINATION_SX = {
  backgroundColor: "#f8f9fa",
  borderTop: "1px solid #e0e0e0",
  "& .MuiTablePagination-toolbar": { color: "#1976d2" },
  "& .MuiTablePagination-selectIcon": { color: "#1976d2" },
};
